import { CircularProgress, Grid, makeStyles } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import * as React from "react";
import { useState } from "react";
import { BooleanInput, Button, Create, TextInput, Toolbar, useNotify } from "react-admin";
import { Form } from "react-final-form";
import { useHistory } from "react-router-dom";
import { useAppDataProvider } from "../../../../src/dataprovider";
import { Separator } from "../../../../src/Components/Separator";
import { SectionTitle } from "../../../../src/Components/SectionTitle";
import { ReliabilityExclusionPnPostModel } from "./Model/ReliabilityExclusionPnModel";

const gridContainerProps: any = {
  container: true,
  direction: "row",
  item: true,
  xs: 12,
  spacing: 1,
  justify: "space-around",
  alignItems: "center",
};

const ReliabilityExclusionPnCreate = props => {
  const dataProvider = useAppDataProvider();
  const notify = useNotify();
  const history = useHistory();
  const [loading, setLoading] = useState(false);

  const useStyles = makeStyles({
    toolbar: {
      display: "flex",
      justifyContent: "end",
      backgroundColor: "white",
    },
    defaultToolbar: {
      display: "flex",
      justifyContent: "end",
    },
  });

  const classes = useStyles();

  const CreateReliabilityExclusionPnButtonClick = e => {
    CreateReliabilityExclusionPn(e);
  };

  const CreateReliabilityExclusionPn = async e => {
    let createModel: ReliabilityExclusionPnPostModel = new ReliabilityExclusionPnPostModel();
    createModel.Pn = e.pn;
    createModel.ExcludeFailOnFit = e.excludeFailOnFit ?? false;
    createModel.ExcludePrematureFailure = e.excludePrematureFailure ?? false;
    createModel.ExcludeRogueUnit = e.excludeRogueUnit ?? false;

    dataProvider
      .postReliabilityExclusionPn(createModel)
      .then(result => {
        notify(`Record created`, "success", false, true);
        history.push("/reliabilityexclusionpns");
      })
      .catch(result => notify(`${result}`, "error", false, true))
      .finally(() => setLoading(false));
  };

  return (
    <Form
      onSubmit={CreateReliabilityExclusionPnButtonClick}
      render={({ handleSubmit, form, values }) => (
        <form>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
              <Create {...props}>
                <>
                  <Separator />
                  <Grid {...gridContainerProps}>
                    <SectionTitle label="Reliability Exclusion PN" />
                  </Grid>
                  <Separator />

                  <Grid {...gridContainerProps}>
                    <Grid item xs={12} sm={5}>
                      <TextInput source="pn" label="Pn" fullWidth variant="outlined" />
                    </Grid>

                    <Grid item xs={12} sm={5}>
                      <BooleanInput label="Exclude Fail on Fit" source="excludeFailOnFit" />
                      <BooleanInput label="Exclude Premature Failure" source="excludePrematureFailure" />
                      <BooleanInput label="Exclude Rogue Unit" source="excludeRogueUnit" />
                    </Grid>
                  </Grid>

                  <Separator />
                  <Toolbar {...props} placeholder="" classes={classes}>
                    <Button
                      label={loading ? "Exclusion PN is creating!" : "Create Exclusion PN"}
                      disabled={loading}
                      size="medium"
                      variant="contained"
                      color="primary"
                      onClick={handleSubmit}
                    >
                      {loading ? <CircularProgress size="2rem" color="secondary" /> : <Add />}
                    </Button>
                  </Toolbar>
                </>
              </Create>
            </Grid>
          </Grid>
        </form>
      )}
    />
  );
};

export default ReliabilityExclusionPnCreate;
